'use strict';

angular.module('atex.dam').factory('configuration', ['$rootScope', 'ApplicationConfigurationService', '$q',
  function($rootScope, ApplicationConfigurationService, $q) {

  var queryOptions;
  var facetOptions;
  var extraFacetOptions;
  var facetRepeatLimit = 10;
  var facetRepeatStep = 10;
  var defaultSortValue = "modificationTime";
  var tabbedSearchDefaultSortValues = {
    "archive": "lpubdate_atex_desk_dt"
  };

  var defaultSelectionTabSearch = {
      set: {}
    };
  var defaultPartitionSearch = "production";
  var trash_externalid = 'dam.assets.trash.d';
  var trash_contentid;

  var collectionsPanelOptions = {
    "sort" : "creationdate_atex_desk_dt desc",
    "rows" : "10"
  };

  var singleValueDimensions = [
    "dimension.partition"
  ];

  var engagementAppTypes = [];

  var engagementAppLinks = [];

  var overrideNewContentMenu = {};

  var overrideEditContentMenu = {};

  var dateTimeFormat = 'yyyy-MM-dd HH:mm:ss';
  var dateFormat = 'yyyy-MM-dd';
  var datePickerFormat = "mm/dd/yy";
  var datePickerDayNamesMin = [ "Su", "Mo", "Tu", "We", "Th", "Fr", "Sa" ];
  var datePickerMonthNamesShort = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

  var solrReplicaPollInterval = 0;

  var maxResultForDynamicSearch = 50;

  var queryTermsInAnd = false;

  var onlyNewInDynQuery = false;

  var inlineEditorForCollection = false;

  var filterAuthorsList = true;

  var maxAuthorsRowsQuery = 50;

  var flagsEnabled = false;

  var publishingScheduleEnabled = false;

  var jobsEnabled = true;

  var exportOnSendToArchive = false;

  var promises = [];

  var jsonAspectsToCompare = ["contentData", "p.InsertionInfo", "atex.WebContentStatus","atex.Metadata"];

  var visiblePublishButtons = ["copyUrl", "openUrl"];

  var url = [];

  var pGalleryFields = [{
      "class" : "dam-thumb-expander-inner-right-head",
      "field" : "Headline"
    },
    {
      "class" : "dam-thumb-expander-inner-right-desc",
      "field" : "Caption"
    }];

  var pGalleryFieldsEdit = [{
    "simple" : true,
    "label" : "Caption",
    "fieldName": "headline"
  },
    {
      "simple" : false,
      "label" : "Description",
      "fieldName": "description"
    }];

  var useLatestSimpleSearch = "latest";

  var useDefaultUTC = true;

  var useUSDateFormat = false;

  var enabledGroupsForDeleteEngagement = ["DevTeam"];

  var enablePublishedContentShortcutEditMode = ["atex.dam.standard.Video", "atex.onecms.article", "atex.dam.standard.Collection", "atex.dam.standard.Audio", "atex.dam.standard.LiveBlog.article"];

  var showBudgetView = false;

  var acePreviewBaseUrl = "";

  var showAcePreviewInDesk = false;

  var broadcastCropFromCollectionToImage = [];

  var downloadFieldList = {
    fields: 'title,shortHeadline,reporter1,reporter2,reporter3,body,newsBox1,newsBox2,newsBox3,newsBox4,newsBox5,newsBox6,newsBox7,newsBox8,newsBox9',
    fieldTypes: 'string,string,string,string,string,string,string,string,string,string,string,string,string,string',
    fieldLabels: '0,1,2,3,4,5,6,7,8,9,10,11,12,13,14',
    fieldBreaks: '1,1,1,1,1,1,1,1,1,1,1,1,1,1,1',
    ext: '.html'
  };

  var escapeTagOnDownloadArticleHtml = 'script[type=\'text/atex-note\'],a[class=\'p-smartembed\']';

  var tagToRemoveOnPreviewHtmlByPartition;

  var notPubblicableContents;

  var desks = [];

  var deskCompanionUrl = "https://chrome.google.com/webstore/detail/desk-chrome-companion/gdagiaiamdkgddabgglkffccpnlbjhhf";

  var dragInputTemplateVsType =  {
    "p.NosqlArticleCollab": "text"
  };

  /* If useChangePrintPageStatus is true, changing the status of a logical page with a counterpart in the print system,
  in the DamChangeStatusModalController we call directly the Layout Server dedicated api in order to be sure to change the status in
  the print system (and in desk in the same time) without relaying to the poller mechanism [max]
   */
  var useChangePrintPageStatus = false;

  var webSectionView = {
    enabled: true,
    excludedSites: ["dam.d"],
    fetchSectionsAtStart: false,
    openFirstLevel: true,
    openAllLevels: false,
    find: {
      size: 28,
      debounce: 200
    },
    search: {
      enabled: true,
      webStatus: ["published"],
      printStatus: [],
      engagement: ["*"]
    }
  };

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'mlt.fl' ]).then(function(data) {
    url['mlt.fl'] = data;
  }));
  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'mlt.minwl' ]).then(function(data) {
    url['mlt.minwl'] = data;
  }));
  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'mlt.mindf' ]).then(function(data) {
    url['mlt.mindf'] = data;
  }));
  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'mlt.mintf' ]).then(function(data) {
    url['mlt.mintf'] = data;
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['showCollectionForbiddenItems']).then(function(showCollectionForbiddenItems) {
    window.atex.dam.cfg.showCollectionForbiddenItems = !!showCollectionForbiddenItems;
  }));
  promises.push(ApplicationConfigurationService.getConfigurationFor(['addNewCollectionItemsOnTop']).then(function(addNewCollectionItemsOnTop) {
    window.atex.dam.cfg.addNewCollectionItemsOnTop = !!addNewCollectionItemsOnTop;
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['queryOptions']).then(function(options) {
    if (options) {
      queryOptions = options;
    }
  }));
  promises.push(ApplicationConfigurationService.getConfigurationFor(['facetOptions']).then(function(options) {
    if (options) {
      facetOptions = options;
    }
  }));
  promises.push(ApplicationConfigurationService.getConfigurationFor(['extraFacetOptions']).then(function(options) {
    if (options) {
      extraFacetOptions = options;
    }
  }));
  promises.push(ApplicationConfigurationService.getConfigurationFor(['facetRepeatLimit']).then(function(options) {
    if (options) {
      facetRepeatLimit = options;
    }
  }));
  promises.push(ApplicationConfigurationService.getConfigurationFor(['facetRepeatStep']).then(function(options) {
    if (options>=0) {
      facetRepeatStep = options;
    }
  }));
  promises.push(ApplicationConfigurationService.getConfigurationFor(['sort']).then(function(sort) {
    if (sort) {
      $rootScope.sortArray = sort;
    }
  }));
  promises.push(ApplicationConfigurationService.getConfigurationFor(['default-sort-value']).then(function(defaultValue) {
    if (defaultValue!==undefined) {
      defaultSortValue = defaultValue;
      $rootScope.damSortData.currentSortValue = defaultValue;
    }
  }));
  promises.push(ApplicationConfigurationService.getConfigurationFor(['tabbed-search-form-defaults']).then(function(defaultValue) {
    if (defaultValue !== undefined) {
      tabbedSearchDefaultSortValues = _.extend(tabbedSearchDefaultSortValues, defaultValue.sort || {});
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['defaultSelectionTabSearch']).then(function(defaultValue) {
    if (defaultValue!==undefined) {
      defaultSelectionTabSearch = defaultValue;
    }
  }));

    promises.push(ApplicationConfigurationService.getConfigurationFor(['defaultPartitionSearch']).then(function(defaultValue) {
      if (typeof defaultValue !== 'undefined') {
        defaultPartitionSearch = defaultValue;
      }
    }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['collectionsPanelOptions']).then(function(preset) {
    if (preset) {
      collectionsPanelOptions = preset;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['singleValueDimensions']).then(function(preset) {
    if (preset) {
      singleValueDimensions = preset;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['engagementAppTypes']).then(function(preset) {
    if (preset) {
      engagementAppTypes = preset;
    }
  }));

    promises.push(ApplicationConfigurationService.getConfigurationFor(['engagementAppLinks']).then(function(preset) {
      if (preset) {
        engagementAppLinks = preset;
      }
    }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['overrideNewContentMenu']).then(function(preset) {
    if (preset) {
      overrideNewContentMenu = preset;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['overrideEditContentMenu']).then(function(preset) {
    if (preset) {
      overrideEditContentMenu = preset;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['dateTimeFormat']).then(function(preset) {
    if (preset) {
      dateTimeFormat = preset;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['dateFormat']).then(function(preset) {
    if (preset) {
      dateFormat = preset;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['datePickerFormat']).then(function(preset) {
    if (preset) {
      datePickerFormat = preset;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['datePickerDayNamesMin']).then(function(preset) {
    if (preset) {
      datePickerDayNamesMin = preset;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['datePickerMonthNamesShort']).then(function(preset) {
    if (preset) {
      datePickerMonthNamesShort = preset;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['solrReplicaPollInterval']).then(function(preset) {
    if (preset) {
      solrReplicaPollInterval = preset * 1;
      if (isNaN(solrReplicaPollInterval)) {
        solrReplicaPollInterval = 0;
      }
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor(['maxResultForDynamicSearch']).then(function(preset) {
    if (preset) {
      maxResultForDynamicSearch = preset;
      if (isNaN(maxResultForDynamicSearch)) {
        maxResultForDynamicSearch = 50;
      }
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'adminGUIUrl' ]).then(function(data) {
    url['adminGUIUrl'] = data;
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'previewUrl' ]).then(function(data) {
    url['previewUrl'] = data;
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'queryTermsInAnd' ]).then(function(data) {
    queryTermsInAnd = data;
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'onlyNewInDynQuery' ]).then(function(data) {
    onlyNewInDynQuery = data;
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'inlineEditorForCollection' ]).then(function(data) {
    inlineEditorForCollection = data;
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'filterAuthorsList' ]).then(function(data) {
    if(data !== undefined) {
      filterAuthorsList = data;
    }
  }));


  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'maxAuthorsRowsQuery' ]).then(function(data) {
    if(data !== undefined) {
      maxAuthorsRowsQuery = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'flagsEnabled' ]).then(function(data) {
    if(data !== undefined) {
      flagsEnabled = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'jobsEnabled' ]).then(function(data) {
    if (data !== undefined) {
      jobsEnabled = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'exportOnSendToArchive' ]).then(function(data) {
    if (data !== undefined) {
      exportOnSendToArchive = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'jsonAspectsToCompare' ]).then(function(data) {
    if (data !== undefined) {
      jsonAspectsToCompare = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'visiblePublishButtons' ]).then(function(data) {
    if (data !== undefined) {
      visiblePublishButtons = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'pGalleryFields' ]).then(function(data) {
    if (data !== undefined) {
      pGalleryFields = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'pGalleryFieldsEdit' ]).then(function(data) {
    if (data !== undefined) {
      pGalleryFieldsEdit = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'useLatestSimpleSearch' ]).then(function(data) {
    if (data !== undefined) {
      useLatestSimpleSearch = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'publishingScheduleEnabled' ]).then(function(data) {
    if (data !== undefined) {
      publishingScheduleEnabled = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'useDefaultUTC' ]).then(function(data) {
    if (data !== undefined) {
      useDefaultUTC = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'useUSDateFormat' ]).then(function(data) {
    if (data !== undefined) {
      useUSDateFormat = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'showBudgetView' ]).then(function(data) {
    if (data !== undefined) {
      showBudgetView = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'acePreviewBaseUrl' ]).then(function(data) {
    if (data !== undefined) {
      acePreviewBaseUrl = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'showAcePreviewInDesk' ]).then(function(data) {
    if (data !== undefined) {
      showAcePreviewInDesk = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'broadcastCropFromCollectionToImage' ]).then(function(data) {
    if (data !== undefined) {
      broadcastCropFromCollectionToImage = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'downloadFieldList' ]).then(function(data) {
    if (data !== undefined) {
      downloadFieldList = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'escapeTagOnDownloadArticleHtml' ]).then(function(data) {
    if (data !== undefined) {
      escapeTagOnDownloadArticleHtml = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'tagToRemoveOnPreviewHtmlByPartition' ]).then(function(data) {
    if (data !== undefined) {
      tagToRemoveOnPreviewHtmlByPartition = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'notPubblicableContents' ]).then(function(data) {
    if (data !== undefined) {
      notPubblicableContents = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'desks' ]).then(function(data) {
    if (data !== undefined) {
      desks = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'deskCompanionUrl' ]).then(function(data) {
    if (data !== undefined) {
      deskCompanionUrl = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'enabledGroupsForDeleteEngagement' ]).then(function(data) {
    if (data !== undefined) {
      enabledGroupsForDeleteEngagement = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'enablePublishedContentShortcutEditMode' ]).then(function(data) {
    if (data !== undefined) {
      enablePublishedContentShortcutEditMode = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'dragInputTemplateVsType' ]).then(function(data) {
    if (data) {
      dragInputTemplateVsType = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'useChangePrintPageStatus' ]).then(function(data) {
    if (data !== undefined) {
      useChangePrintPageStatus = data;
    }
  }));

  promises.push(ApplicationConfigurationService.getConfigurationFor([ 'webSectionsWidget' ]).then(function(data) {
    if (data !== undefined) {
      webSectionView = _.extend({}, webSectionView, data);
    }
  }));

  var configuration = {};
  var isReady = false;

  var allPromises = $q.all(promises).then(function () {
    isReady = true;
    return configuration;
  });

  var warnIfNotReady = function () {
    if (!isReady) {
      console.warn ("Trying to use configuration before it is ready - change to use a promise");
    }
  };

  configuration = {

    whenReady : function() {

      return allPromises;
    },

    getUrl : function() {
      warnIfNotReady();
      return "&mlt.fl=" + url['mlt.fl'] + "&mlt.interestingTerms=list&mlt.boost=true&mlt.match.include=false" + "&mlt.minwl=" +
          url['mlt.minwl'] + "&mlt.mindf=" + url['mlt.mindf'] + "&mlt.mintf=" + url['mlt.mintf'] + "&wt=json";
    },

    getQueryOptions : function() {
      warnIfNotReady();
      return queryOptions;
    },

    getFacetOptions : function() {
      warnIfNotReady();
      return facetOptions;
    },

    getExtraFacetOptions : function() {
      warnIfNotReady();
      return extraFacetOptions;
    },

    getFacetRepeatLimit : function() {
      warnIfNotReady();
      return facetRepeatLimit;
    },

    getFacetRepeatStep : function() {
      return allPromises.then(function () {
        return facetRepeatStep;
      });
    },

    getDefaultSortValue : function() {
      return allPromises.then(function () {
        return defaultSortValue;
      });
    },

    getDefaultTabSortValue : function(name) {
      return allPromises.then(function () {
        return tabbedSearchDefaultSortValues[name] || defaultSortValue;
      });
    },

    getDefaultSelectionTabSearch : function() {
      return allPromises.then(function () {
        return defaultSelectionTabSearch;
      });
    },

    getDefaultPartitionSearch : function() {
      return allPromises.then(function () {
        return defaultPartitionSearch;
      });
    },

    getTrashExternalId : function() {
      warnIfNotReady();
      return trash_externalid;
    },

    setTrashId : function(trashContentID) {
      warnIfNotReady();
      trash_contentid = trashContentID;
    },

    getTrashId : function() {
      warnIfNotReady();
      return trash_contentid;
    },

    getCollectionsPanelOptions : function() {
      warnIfNotReady();
      return collectionsPanelOptions;
    },

    getSingleValueDimensions : function() {
      warnIfNotReady();
      return singleValueDimensions;
    },

    getEngagementAppTypes : function() {
      warnIfNotReady();
      return engagementAppTypes;
    },

    getEngagementAppLinks : function() {
      warnIfNotReady();
      return engagementAppLinks;
    },

    getOverrideNewContentMenu : function() {
      warnIfNotReady();
      return overrideNewContentMenu;
    },

    getOverrideEditContentMenu : function() {
      warnIfNotReady();
      return overrideEditContentMenu;
    },

    getQueryFilterTrash : function() {
      warnIfNotReady();
      var filterOnTrash = '';
      if (trash_contentid) {
        filterOnTrash = '-page_ss:("' + trash_contentid.replace('contentid/', '') + '")';
      }
      return filterOnTrash;
    },

    getDateTimeFormat : function() {
      warnIfNotReady();
      return dateTimeFormat;
    },

    getDateFormat : function() {
      warnIfNotReady();
      return dateFormat;
    },

    getDatePickerFormat : function() {
      warnIfNotReady();
      return datePickerFormat;
    },

    getDatePickerDayNamesMin : function() {
      warnIfNotReady();
      return datePickerDayNamesMin;
    },

    getDatePickerMonthNamesShort : function() {
      warnIfNotReady();
      return datePickerMonthNamesShort;
    },

    getSolrReplicaPollInterval : function() {
      warnIfNotReady();
      return solrReplicaPollInterval;
    },

    getMaxResultForDynamicSearch: function() {
      warnIfNotReady();
      return maxResultForDynamicSearch;
    },

    getAdminGUIUrl: function() {
      warnIfNotReady();
      return url['adminGUIUrl'];
    },

    getPreviewUrl: function() {
      warnIfNotReady();
      return url['previewUrl'];
    },

    getQueryTermsInAnd: function() {
      warnIfNotReady();
      return queryTermsInAnd;
    },

    getOnlyNewInDynQuery: function() {
      warnIfNotReady();
      return onlyNewInDynQuery;
    },

    getInlineEditorForCollection: function() {
      warnIfNotReady();
      return inlineEditorForCollection;
    },

    getFilterAuthorsList: function() {
      warnIfNotReady();
      return filterAuthorsList;
    },

    getMaxAuthorsRowsQuery: function() {
      warnIfNotReady();
      return maxAuthorsRowsQuery;
    },



    getFlagsEnabled: function() {
      return allPromises.then(function() {
        return flagsEnabled;
      });
    },

    getPublishingScheduleEnabled: function() {
      return allPromises.then(function () {
        return publishingScheduleEnabled;
      });
    },

    getJobsEnabled: function() {
      return allPromises.then(function () {
        return jobsEnabled;
      });
    },

    getExportOnSendToArchive: function() {
      warnIfNotReady();
      return exportOnSendToArchive;
    },

    getJsonAspectsToCompare: function() {
      warnIfNotReady();
      return jsonAspectsToCompare;
    },

    getVisiblePublishButtons: function() {
      warnIfNotReady();
      return visiblePublishButtons;
    },

    getPGalleryFields: function() {
      warnIfNotReady();
      return pGalleryFields;
    },

    getPGalleryFieldsEdit: function() {
      warnIfNotReady();
      return pGalleryFieldsEdit;
    },

    getuseLatestSimpleSearch: function() {
      warnIfNotReady();
      return useLatestSimpleSearch;
    },

    getUseDefaultUTC: function() {
      warnIfNotReady();
      return useDefaultUTC;
    },

    getUseUSDateFormat: function() {
      warnIfNotReady();
      return useUSDateFormat;
    },

    getShowBudgetView: function() {
      warnIfNotReady();
      return showBudgetView;
    },

    getAcePreviewBaseUrl: function() {
      warnIfNotReady();
      return acePreviewBaseUrl;
    },

    getShowAcePreviewInDesk: function() {
      warnIfNotReady();
      return showAcePreviewInDesk;
    },

    getBroadcastCropFromCollectionToImage: function() {
      warnIfNotReady();
      return broadcastCropFromCollectionToImage;
    },

    getDownloadFieldList: function() {
      warnIfNotReady();
      return downloadFieldList;
    },

    getEscapeTagOnDownloadArticleHtml: function() {
      warnIfNotReady();
      return escapeTagOnDownloadArticleHtml;
    },

    getTagToRemoveOnPreviewHtmlByPartition: function() {
      warnIfNotReady();
      return tagToRemoveOnPreviewHtmlByPartition;
    },

    getNotPubblicableContents: function() {
      warnIfNotReady();
      return notPubblicableContents;
    },

    getDesks: function() {
      warnIfNotReady();
      return desks;
    },

    getDeskCompanionUrl: function() {
      warnIfNotReady();
      return deskCompanionUrl;
    },

    getEnabledGroupsForDeleteEngagement: function() {
      warnIfNotReady();
      return enabledGroupsForDeleteEngagement;
    },
    getEnablePublishedContentShortcutEditMode: function() {
      warnIfNotReady();
      return enablePublishedContentShortcutEditMode;
    },

    getDragType: function(inputTemplate) {
      warnIfNotReady();
      return dragInputTemplateVsType && dragInputTemplateVsType[inputTemplate];
    },

    getUseChangePrintPageStatus: function() {
      warnIfNotReady();
      return useChangePrintPageStatus;
    },

    getWebSectionWidget: function() {
      warnIfNotReady();
      return webSectionView;
    }
  };

  return configuration;

}]);
